import { formatPlural } from '@lbcamden/shared-utils';
import z from 'zod';

z.config({
  customError: (iss) => {
    if (iss.input === undefined) {
      return 'Required';
    }
    if (iss.code === 'too_small' && iss.origin === 'string') {
      return `Must be at least ${iss.minimum} ${formatPlural('character', Number(iss.minimum))}`;
    }
    if (iss.code === 'too_big' && iss.origin === 'string') {
      return `Must be no more than ${iss.maximum} ${formatPlural('character', Number(iss.maximum))}`;
    }
    if (iss.code === 'invalid_format' && iss.format === 'date') {
      return 'Invalid date';
    }
  },
});
